export default {
  create_title: 'Nueva cuenta de Partner API',
  edit_title: 'Editar cuenta',
  form: {
    name: 'Nombre de la cuenta',
    name_placeholder: 'p. ej. Integración POS Acme',
    contact_email: 'Correo de contacto',
    scope: 'Acceso a restaurantes',
    companies: 'Restaurantes',
    scope_selected: 'Restaurantes seleccionados',
    scope_all: 'Todos los restaurantes',
    scope_all_help:
      'Las claves de esta cuenta acceden a todos los restaurantes de tu organización, incluidos los que se registren más adelante.',
    companies_help: 'Las claves emitidas en esta cuenta solo pueden leer y escribir estos restaurantes.',
    is_active: 'Activo',
    is_active_help: 'Las cuentas inactivas se rechazan en la autenticación.',
  },
  buttons: {
    cancel: 'Cancelar',
    save: 'Guardar',
    create: 'Crear',
  },
  toasts: {
    created: 'Cuenta de Partner API creada.',
    updated: 'Cuenta actualizada.',
    error: 'No se pudo guardar la cuenta.',
  },
};
